import { Button, Grid } from "@material-ui/core";
import { useContext } from "react";
import { Title, useAuthenticated, useRedirect } from "react-admin";
import QuizInstitutionList from "../../components/dashboards/quiz-dashboard/quiz-institution-list.component";
import QuizInstitutionStats from "../../components/dashboards/quiz-dashboard/quiz-institution-stats.component";
import QuizList from "../../components/dashboards/quiz-dashboard/quiz-list.component";
import QuizStats from "../../components/dashboards/quiz-dashboard/quiz-stats.component";
import { AppContext } from "../../providers/app-context-provider/app.context";
import { ProfileEnum } from "../../utils/general-profile.enum";


const QuizPractice = () => {
    useAuthenticated()
    const redirect = useRedirect();
    const context = useContext(AppContext)
    const isStudent = context.profile.name === ProfileEnum.STUDENT
    return (
        <Grid container>
            <Title title={'Juristta Quiz - Prática'} />
            <Button
                style={{ width: '250px', marginBottom: '32px' }}
                onClick={() => redirect(isStudent ? '/quiz' : '/instant-quiz')}
                variant="contained"
                color="primary">
                {isStudent ? 'Novo Quiz' : 'Gerar Quiz Prática'}
            </Button>
            {isStudent ? <QuizStats /> : <QuizInstitutionStats />}
            {isStudent ? <QuizList /> : <QuizInstitutionList />}
        </Grid >
    )
}

export default QuizPractice